/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Toolbar, TextField } from '@material-ui/core';

/**
 * region for styles*/
import { headerKeywordStyle } from './style/headerKeywordStyle';

/**
 * region for components*/
import HeaderTitle from '../../components/common/HeaderTitle';
import InputSearchKeyword from '../../components/keyword/InputSearchKeyword';
import MenuFiltersKeyword from '../../components/keyword/MenuFiltersKeyword';

class HeaderKeyword extends Component {

    render() {
        const { classes } = this.props;
        return (
            <Toolbar>
                <HeaderTitle title={this.props.titleSearchKeyword}/>
                <InputSearchKeyword noWrap
                    searchKeyword={this.props.searchKeyword}
                    handleChange={this.props.handleChange}
                    onKeyPressSearchFilter={this.props.onKeyPressSearchFilter} />

                <MenuFiltersKeyword
                    checkInsufficientContent={this.props.checkInsufficientContent}
                    handleChangeCheckInsufficientContent={this.props.handleChangeCheckInsufficientContent}
                    checkEqualToCategory={this.props.checkEqualToCategory}
                    handleChangeCheckEqualToCategory ={this.props.handleChangeCheckEqualToCategory}
                />

                <TextField
                    className={classes.textField}
                    id="idStaff"
                    style={{ marginTop: 8, marginBottom: 8 }}
                    margin="normal"
                    value={this.props.currentStaff}
                    select={true}
                    defaultValue={0}
                    onChange={this.props.onChangeSelectStaff}
                    variant="outlined"
                    size="small"
                >
                    {this.props.selectStaff}
                </TextField>
            </Toolbar>
        );
    }
}
HeaderKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(headerKeywordStyle)(HeaderKeyword);